<template>
    <v-content>
        <v-row class="pb-0 pb-sm-2">
            <v-col class="display-1">
                Instant рассылки
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-select
                    v-model="status.value"
                    @change="getDeliveries"
                    :items="statuses"
                    item-text="name"
                    item-value="value"
                    label="Статус"
                    clearable
                    outlined
                    hide-details
                    dense
                  />
            </v-col>
            <v-col>
                <v-select
                    v-model="type.value"
                    @change="getDeliveries"
                    :items="types"
                    item-text="name"
                    item-value="value"
                    label="Тип рассылки"
                    outlined
                    hide-details
                    clearable
                    dense
                  />
            </v-col>
        </v-row>
        <b-table
            :data="deliveries.results"
            :loading="isLoading"
            paginated
            backend-pagination
            :total="deliveries.total"
            :per-page="perPage.value"
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            backend-sorting
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
        >
            <template slot-scope="props">
                <b-table-column field="id" label="ID" style="width: 50px;" numeric sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="type" label="Тип" style="width: 50px;">
                    {{
                        types.find(o => o.value === props.row.type) ? types.find(o => o.value === props.row.type).name : props.row.type
                    }}
                </b-table-column>

                <b-table-column field="template" label="Шаблон">
                    {{ props.row.notification_template ? props.row.notification_template.name : 'Не найдено'}}
                </b-table-column>

                <b-table-column field="created_at" label="Создано" sortable>
                    {{ props.row.created_at | isoToDateTime}}
                </b-table-column>

                <b-table-column field="planned_at" label="Запланировано на" sortable>
                    {{ props.row.planned_at | isoToDateTime}}
                </b-table-column>

                <b-table-column field="status" label="Статус">
                    {{ statuses.find(o => o.value === props.row.status) ? statuses.find(o => o.value === props.row.status).name : props.row.status }}
                </b-table-column>

                <b-table-column
                      label="Действия"
                      centered
                  >
                  <b-tooltip
                      v-if="['created', 'restarted'].includes(props.row.status)"
                      label="Остановить">
                      <div
                          @click="pauseDelivery(props.row.id)">
                          <b-icon
                              icon="pause"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                  <b-tooltip
                      v-if="props.row.status==='created'"
                      label="Изменить">
                      <div
                          @click="updateDelivery(props.row.id)">
                          <b-icon
                              icon="pencil"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                  <b-tooltip
                      v-else-if="['paused', 'failed'].includes(props.row.status)"
                      label="Возобновить">
                      <div
                          @click="restartDelivery(props.row.id)">
                          <b-icon
                              icon="play"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                </b-table-column>
            </template>
              <template slot="bottom-left">
                <div class="pagination-controls">
                  <v-select
                    style="width: fit-content; float: left;"
                    v-model="perPage.value"
                    @change="getDeliveries"
                    :items="perPageOptions"
                    item-text="name"
                    item-value="value"
                    outlined
                    hide-details
                    dense
                  />
                </div>
            </template>
        </b-table>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: 'DeliveryList',
    components: {
        OverlayLoader,
    },
    data() {
        return {
            sortField: "id",
            sortOrder: "desc",
            page: 1,
            perPage: {
                value: 20,
            },
            type: {
                value: null,
            },
            status: {
                value: null,
            },
            statuses: [
                { name: "Готово", value: 'done' },
                { name: "Не удалось", value: 'failed' },
                { name: "Создано", value: 'created' },
                { name: "Возобновлено", value: 'restarted' },
                { name: "Остановлено", value: 'paused' },
            ],
            perPageOptions: [
                { name: "10 на странице", value: 10 },
                { name: "20 на странице", value: 20 },
                { name: "50 на странице", value: 50 },
                { name: "100 на странице", value: 100 },
            ],
            types: [
                { name: "Смс", value: 'sms' },
                { name: "Звонок", value: 'call' },
            ],
        }
    },
    created() {
        this.getDeliveries();
    },
    computed: {
        deliveries() {
            return this.$store.getters.DELIVERIES_LIST;
        },
        isLoading() {
            return this.$store.getters.DELIVERIES_LOADING;
        },
    },
    methods: {
        pauseDelivery(id) {
          this.$store.dispatch('PAUSE_DELIVERY', id)
              .then(() => {
                  this.$toaster.success('Уведомление отменено');
              })
              .catch(() => {
                  this.$toaster.error('Ошибка при отмене');
              })
              .finally(() => {
                  this.getDeliveries();
              });
        },
        restartDelivery(id) {
          this.$store.dispatch('RESTART_DELIVERY', id)
              .then(() => {
                  this.$toaster.success('Уведомление возобновлено');
              })
              .catch(() => {
                  this.$toaster.error('Ошибка при возобновлении');
              })
              .finally(() => {
                  this.getDeliveries();
              });
        },
        updateDelivery(id) {
          this.$store.dispatch('UPDATE_DELIVERY', id)
              .then(() => {
                  this.$toaster.success('Уведомление возобновлено');
              })
              .catch(() => {
                  this.$toaster.error('Ошибка при возобновлении');
              })
              .finally(() => {
                  this.getDeliveries();
              });
        },
        getDeliveries() {
            const params = {
                sort_by: this.sortField,
                order: this.sortOrder,
                page: this.page,
                perPage: this.perPage.value,
                type: this.type.value,
                status: this.status.value,
            };
            this.$store.dispatch('GET_DELIVERIES_LIST', params);
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.getDeliveries();
        },
        onPageChange(page) {
            this.page = page;
            this.getDeliveries();
        },
    }
}
</script>
